var accordion = document.getElementsByClassName("accordion-header");
var debounce = false; // To prevent multiple clicks

for (let i = 0; i < accordion.length; i++) {
	accordion[i].addEventListener("click", () => {
		if (debounce) return; // Exit if debounce is active
		debounce = true; // Activate debounce

		const accordionContent = accordion[i].nextElementSibling;
		let isClosed;
		if (
			accordionContent.style.maxHeight == "0px" ||
			accordionContent.style.maxHeight == ""
		) {
			isClosed = true;
		} else {
			isClosed = false;
		}

		console.log(isClosed);

		if (isClosed) {
			accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
		} else {
			accordionContent.style.maxHeight = "0px";
		}

		// Reset debounce after the transition duration
		setTimeout(() => {
			debounce = false;
		}, 300); // Adjust duration based on your CSS transition time
	});
}
